__turbopack_context__.v({
  "accordionSlideOverwrite": "inviteAFriendModal-module-scss-module__1W7z9q__accordionSlideOverwrite",
  "content": "inviteAFriendModal-module-scss-module__1W7z9q__content",
  "fadeIn": "inviteAFriendModal-module-scss-module__1W7z9q__fadeIn",
  "fadeOut": "inviteAFriendModal-module-scss-module__1W7z9q__fadeOut",
  "footer": "inviteAFriendModal-module-scss-module__1W7z9q__footer",
  "header": "inviteAFriendModal-module-scss-module__1W7z9q__header",
  "inviteModal": "inviteAFriendModal-module-scss-module__1W7z9q__inviteModal",
  "overlay": "inviteAFriendModal-module-scss-module__1W7z9q__overlay",
  "scaleIn": "inviteAFriendModal-module-scss-module__1W7z9q__scaleIn",
  "scaleOut": "inviteAFriendModal-module-scss-module__1W7z9q__scaleOut",
  "sendButton": "inviteAFriendModal-module-scss-module__1W7z9q__sendButton",
  "title": "inviteAFriendModal-module-scss-module__1W7z9q__title",
  "zoomIn": "inviteAFriendModal-module-scss-module__1W7z9q__zoomIn",
  "zoomOut": "inviteAFriendModal-module-scss-module__1W7z9q__zoomOut",
});
